function number(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
export function businessDistance(distance, percentage) {
  const km = number(distance), share = number(percentage);
  if (km === null || km < 0 || share === null || share < 0 || share > 100) {
    throw new Error('Trip distance and business use must be valid numbers.');
  }
  return km * share / 100;
}
export function tripTotals(trips) {
  return trips.reduce((sum, trip) => ({
    recordedDistance: sum.recordedDistance + Number(trip.distance_km),
    businessDistance: sum.businessDistance + businessDistance(trip.distance_km, trip.business_use_percentage)
  }), {recordedDistance: 0, businessDistance: 0});
}
export function calculateFuelCost(distanceKm, consumption, fuelPrice) {
  const km = number(distanceKm), rate = number(consumption), price = number(fuelPrice);
  if (km === null || km < 0 || rate === null || rate <= 0 || price === null || price <= 0) return null;
  const cost = km / 100 * rate * price;
  return Number.isFinite(cost) ? cost : null;
}
function coordinate(value, minimum, maximum) {
  const parsed = number(value);
  return parsed !== null && parsed >= minimum && parsed <= maximum ? Math.round(parsed * 100000) / 100000 : null;
}
function accuracy(value) {
  const parsed = number(value);
  return parsed === null || parsed < 0 ? null : Math.round(parsed * 100) / 100;
}
export function tripPayload(values) {
  if (!['odometer', 'manual', 'route_estimate'].includes(values.distanceMethod)) throw new Error('Choose odometer, route estimate, or manual distance.');
  const start = number(values.startOdometer), end = number(values.endOdometer);
  if (values.distanceMethod === 'odometer' && (!values.vehicleId || start === null || start < 0 || end === null || end <= start)) {
    throw new Error('Choose a vehicle and enter an end odometer above the start reading.');
  }
  const routeMeters = number(values.routeDistanceMeters);
  const routeDuration = number(values.routeDurationSeconds);
  const startLatitude = coordinate(values.startLatitude, -90, 90);
  const startLongitude = coordinate(values.startLongitude, -180, 180);
  const endLatitude = coordinate(values.endLatitude, -90, 90);
  const endLongitude = coordinate(values.endLongitude, -180, 180);
  if (values.distanceMethod === 'route_estimate' && (
    !values.startLocation?.trim() || !values.endLocation?.trim()
    || startLatitude === null || startLongitude === null || endLatitude === null || endLongitude === null
    || routeMeters === null || routeMeters <= 0 || routeMeters > 20000000 || !Number.isInteger(routeMeters)
    || routeDuration === null || routeDuration < 0 || routeDuration > 2592000 || !Number.isInteger(routeDuration)
    || values.routeProvider !== 'mapbox' || !values.routeEstimatedAt
  )) throw new Error('Choose a start and destination, then calculate the driving route.');
  const distance = values.distanceMethod === 'odometer'
    ? Math.round((end - start) * 100) / 100
    : values.distanceMethod === 'route_estimate'
      ? Math.round(routeMeters / 10) / 100
      : number(values.distance);
  if (distance === null || distance <= 0) throw new Error('Trip distance must be greater than zero.');
  businessDistance(distance, values.businessUsePercentage);
  return {
    vehicle_id: values.vehicleId || null, trip_date: values.tripDate, purpose: values.purpose,
    client_name: values.clientName?.trim() || null, start_location: values.startLocation?.trim() || null,
    end_location: values.endLocation?.trim() || null,
    start_latitude: values.distanceMethod === 'route_estimate' ? startLatitude : null,
    start_longitude: values.distanceMethod === 'route_estimate' ? startLongitude : null,
    start_accuracy_m: values.distanceMethod === 'route_estimate' ? accuracy(values.startAccuracy) : null,
    start_location_source: values.distanceMethod === 'route_estimate' ? values.startLocationSource || 'search' : null,
    end_latitude: values.distanceMethod === 'route_estimate' ? endLatitude : null,
    end_longitude: values.distanceMethod === 'route_estimate' ? endLongitude : null,
    end_accuracy_m: values.distanceMethod === 'route_estimate' ? accuracy(values.endAccuracy) : null,
    end_location_source: values.distanceMethod === 'route_estimate' ? values.endLocationSource || 'search' : null,
    start_odometer_km: values.distanceMethod === 'odometer' ? start : null,
    end_odometer_km: values.distanceMethod === 'odometer' ? end : null,
    distance_km: distance, distance_method: values.distanceMethod,
    route_distance_meters: values.distanceMethod === 'route_estimate' ? routeMeters : null,
    route_duration_seconds: values.distanceMethod === 'route_estimate' ? routeDuration : null,
    route_provider: values.distanceMethod === 'route_estimate' ? values.routeProvider : null,
    route_estimated_at: values.distanceMethod === 'route_estimate' ? values.routeEstimatedAt : null,
    business_use_percentage: Number(values.businessUsePercentage), notes: values.notes?.trim() || null
  };
}
